import React, { useState } from 'react'
import { Mail, ArrowRight, Clock } from 'lucide-react'

const SignUp: React.FC = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) return

    setIsLoading(true)
    setMessage('')

    try {
      const response = await fetch('https://newsletter-backend.dhkim79.workers.dev/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      })

      const data = await response.json()
      setMessage(data.message)
      
      if (data.success) {
        setEmail('')
      }
    } catch (error) {
      setMessage('구독 중 오류가 발생했습니다. 다시 시도해주세요.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-max">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex items-center justify-center mb-6">
            <Clock className="w-8 h-8 text-primary-600 mr-3" />
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              5초면 충분합니다
            </h2>
          </div>

          <p className="text-lg text-gray-600 mb-8">
            이메일만 입력하면 즉시 구독이 완료됩니다
          </p>

          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1 relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="이메일 주소를 입력하세요"
                  className="input-field pl-12"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className="btn-primary flex items-center justify-center gap-2 whitespace-nowrap"
              >
                {isLoading ? (
                  '구독 중...'
                ) : (
                  <>
                    무료 구독하기
                    <ArrowRight className="w-5 h-5" />
                  </>
                )}
              </button>
            </div>
            
            {message && (
              <p className={`mt-4 text-sm ${
                message.includes('완료') || message.includes('재활성화') 
                  ? 'text-green-600' 
                  : 'text-red-600'
              }`}>
                {message}
              </p>
            )}
          </form>

          <div className="mt-8 text-sm text-gray-500">
            <p>구독 취소는 언제든지 가능합니다</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SignUp
